<script lang="ts">
  import PartnersScroller from './company/components/PartnersScroller.svelte'
  import Community from './components/Community.svelte'
  import Footer from './components/Footer.svelte'
  import CDPs from './homepage/components/CDPs.svelte'
  import CollateralOptions from './homepage/components/CollateralOptions.svelte'
  import HomepageHero from './homepage/components/HomepageHero.svelte'
  import Statistics from './homepage/components/Statistics.svelte'
  import Synthetics from './homepage/components/Synthetics.svelte'
  import Tokenomics from './homepage/components/Tokenomics.svelte'
</script>

<div class="fade-in relative z-[1] space-y-16 md:space-y-32 sm-desktop:space-y-52 lg-desktop:space-y-64">
  <HomepageHero />
  <Statistics />
  <Synthetics />
  <CDPs />
  <CollateralOptions />
  <Tokenomics />
  <div class="space-y-4 overflow-hidden pt-[2rem]">
    <PartnersScroller />
    <Community />
  </div>
  <Footer nextPage="Platform" pageLink="/platform" />
</div>
